import { useContext } from 'react';

import { SessionContext } from '@/utils/auth/SessionContext';
import type { Session } from '@/types/session.types';

export default function useSession(): Session {
  return useContext(SessionContext);
}
